import { getTagsClause } from './getTagsClause';

export function makeEnvironmentSpec(projectKey: string, environmentKey: string, tags: ArrayLike<string>) {
  return `proj/${projectKey}:env/${environmentKey}${getTagsClause(tags)}`;
}
